import React, {Component} from 'react';
import {Button, Dropdown, Popup, Modal, Form, Grid} from 'semantic-ui-react';

import PrinterData from "../../data/PrinterData";
import {connect} from "react-redux";
import {showAlert} from "../../actions/AlertAction";
import {openPrinterSettingsModal} from "../../actions/PrinterSettingsModalAction";
import {showToast} from "../../actions/ToastAction";
import {showModalInvoiceByEmail} from "../../actions/SendInvoiceByEmailActions";
import SaleData from "../../data/SaleData";
import DataService from "../../functions/DataService";
import {listProductsSale} from "../../actions/ProductsSaleActions";
import SaleItemData from "../../data/SaleItemData";
let GLOBAL = require('../../data/globals');

class PrintSaleButtons extends Component {

    constructor(props){
        super(props);
        
        this.state = {
            sale: props.sale,
            notes: props.notes,
            sending_ticket: false,
            sending_order: false,
            modal_notes: false,
            sending_notes: false
        };
    }

    componentDidMount() {
        DataService.get(`api/account/token-uid`, {}).then(auth=>{
            this.setState({auth})
        }).catch(()=>{
            console.log('error');
        })
    }

    handlePrint = () => {
        this.setState({sending_ticket: true});
        PrinterData.printInvoice(this.state.sale, null).then((res) =>{
            this.props.showToast({message:res, type:'success'});
            this.setState({sending_ticket: false});
            this.list_sale_items('all');
        }, err =>{
            if(err === 1){
                this.props.openPrinterSettingsModal({is_open:true});
            }else if(err === 2){
                this.props.showToast({message:'Tenemos un problema en el servidor', type:'error'});
            }
            this.setState({sending_ticket: false});
        })
    };

    handlePrintOrder = (items) => {
        this.setState({sending_order: true});
        PrinterData.printOrder(this.state.sale, items, null).then((res) =>{
            this.props.showToast({message:res, type:'success'});
            this.setState({sending_order: false});
            this.list_sale_items();
        }, err =>{
            if(err === 1){
                this.props.openPrinterSettingsModal({is_open:true});
            }else if(err === 2){
                this.props.showToast({message:'Tenemos un problema en el servidor', type:'error'});
            }
            this.setState({sending_order: false});
        })
    };

    invoiceByEmail = () =>{
        this.props.showModalInvoiceByEmail({
            show:true,
            id:this.state.sale
        });
    };

    handleToggleModalNotes = () => {
        this.setState({ modal_notes: !this.state.modal_notes });
    };

    async list_sale_items(){
        let products_sale = await SaleItemData.getList(this.state.sale);
        this.props.listProductsSale(products_sale);
    }

    handleSubmitNotes = () => {
        this.setState({ sending_notes: true });
        let data = { sale: this.state.sale, notes: this.state.notes };
        SaleData.notes(data, (res) => {
            if (res.update) {
                this.props.showToast({ message: 'Notas actualizadas!', type: 'success' });
            } else {
                this.props.showToast({ message: 'Tenemos un problema!', type: 'error' });
            }
            this.setState({ sending_notes: false });
            this.handleToggleModalNotes();
        });
    };

    handleNotesChange = (event) => {
        this.setState({ notes: event.target.value });
    };

    downloadInvoicePDF = () => {
        window.open(`${GLOBAL.BASE_URL}api/sales/${this.state.sale}/invoice-pdf?token=${this.state.auth.token}&uid=${this.state.auth.uid}`, '_blank').focus();
    };


    render() {
        return (
            <div>
                <Button.Group fluid>
                    <Popup
                        trigger={
                            <Button
                                icon='ticket'
                                onClick={this.handlePrint}
                                loading={this.state.sending_ticket}
                                disabled={this.state.sending_ticket}
                        />}
                        content='Imprimir factura'
                        size='tiny'
                    />
                    <Popup
                        trigger={<Dropdown icon='sticky note' floating button className='icon'>
                            <Dropdown.Menu>
                                <Dropdown.Header content='Comandas' />
                                <Dropdown.Divider />
                                <Dropdown.Item
                                    icon='ticket'
                                    loading={this.state.sending_ticket}
                                    disabled={this.state.sending_ticket}
                                    text='Imprimir toda la comanda'
                                    onClick={() => this.handlePrintOrder('all')}
                                />
                                <Dropdown.Item
                                    icon='ticket'
                                    text='Imprimir últimos productos'
                                    onClick={() => this.handlePrintOrder('last')}
                                />
                            </Dropdown.Menu>
                        </Dropdown>}
                        content='Imprimir comanda'
                        size='tiny'
                    />
                    <Popup
                        trigger={<Dropdown icon='print' floating button className='icon'>
                            <Dropdown.Menu>
                                <Dropdown.Header content='Otras Opciones para imprimir' />
                                <Dropdown.Divider />
                                <Dropdown.Item icon='mail' text='Enviar factura por email' onClick={this.invoiceByEmail}/>
                                <Dropdown.Item icon='file pdf' text='Descargar factura en PDF' onClick={this.downloadInvoicePDF}/>
                            </Dropdown.Menu>
                        </Dropdown>}
                        content='Otras formas de imprimir'
                        size='tiny'
                    />
                    <Popup
                        trigger={
                            <Button
                                icon='book'
                                onClick={this.handleToggleModalNotes}
                            />}
                        content='Notas'
                        size='tiny'
                    />
                </Button.Group>
                <Modal open={this.state.modal_notes} size='tiny' dimmer='inverted' onClose={this.handleCloseModalNotes}>
                    <Modal.Header>Notas</Modal.Header>
                    <Modal.Content image>
                        <Modal.Description>
                            <Form>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Form.TextArea
                                                label='Notas'
                                                placeholder='Notas u observaciones'
                                                value={this.state.notes}
                                                multiline='true'
                                                onChange={this.handleNotesChange}
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleToggleModalNotes} content="Cancelar" />
                        <Button primary icon='save' disabled={this.state.sending_notes} loading={this.state.sending_notes} labelPosition='left' content='Guardar' onClick={this.handleSubmitNotes} />
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showAlert(modal){
            dispatch(showAlert(modal))
        },
        openPrinterSettingsModal(modal){
            dispatch(openPrinterSettingsModal(modal))
        },
        showToast(toast){
            dispatch(showToast(toast))
        },
        showModalInvoiceByEmail(modal){
            dispatch(showModalInvoiceByEmail(modal))
        },
        listProductsSale(products_sale) {
            dispatch(listProductsSale(products_sale));
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(PrintSaleButtons)



// WEBPACK FOOTER //
// ./src/components/sale/PrintSaleButtons.js